
import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

$('.hero-slider').each(function(){
  
  var $element = $(this);
  var mySwiper = new Swiper($element[0], {
    // Optional parameters
    // direction: 'vertical',
    // loop: true,
    fadeEffect: { crossFade: true },
    effect: 'fade',
    

    // centeredSlides: true,
    speed: 1000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    breakpoints: {
      // when window width is >= 640px
      0: {
        pagination: false,
      },
      768: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      }
    },

  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  })
  
  setTimeout(function(){ 
    window.dispatchEvent(new Event('resize'));
  }, 100);
  
  setTimeout(function(){ 
    window.dispatchEvent(new Event('resize'));
  }, 500);
});



